var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 19.75V17.9167C18.3334 16.9442 17.9471 16.0116 17.2595 15.3239C16.5718 14.6363 15.6392 14.25 14.6667 14.25H7.33341C6.36095 14.25 5.42832 14.6363 4.74069 15.3239C4.05306 16.0116 3.66675 16.9442 3.66675 17.9167V19.75",
    stroke: "#193566",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 10.5833C13.0252 10.5833 14.6668 8.94171 14.6668 6.91667C14.6668 4.89162 13.0252 3.25 11.0002 3.25C8.97512 3.25 7.3335 4.89162 7.3335 6.91667C7.3335 8.94171 8.97512 10.5833 11.0002 10.5833Z",
    stroke: "#193566",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserButton);
export default __webpack_public_path__ + "static/media/user-button.f32cf1967406bf286c752b9825cf2890.svg";
export { ForwardRef as ReactComponent };